<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    :title="'关联平台'"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="50%"
    top="10vh"
    :close-on-click-modal="false"
  >
    <div class="former">
      <select2
        v-model="form.client_id"
        url="client"
        labelName="ClientName"
        placeholder="请选择客户"
        no-data-text="无客户"
      ></select2>&nbsp;
      <select2
        v-model="form.BusinessTypeID"
        url="basic?type=BusinessType"
        placeholder="请选择业务类型"
        noDataText="无类型"
      ></select2>&nbsp;
      <el-button type="primary" @click="onSubmitQuery">
        <i class="fas fa-search"></i>
      </el-button>
    </div>
    <el-table
      :data="itemList"
      v-loading="loading"
      :row-key="getRowKey"
      @selection-change="handleSelectionChange"
      ref="multipleTable"
    >
      <el-table-column type="index"></el-table-column>
      <el-table-column prop="PlatformName" label="平台名称"></el-table-column>
      <el-table-column label="客户名称">
        <template slot-scope="{ row }">
          {{ row.Contract && row.Contract.length
          ? row.Contract[0].Client.ClientName
          : '-'}}
        </template>
      </el-table-column>
      <el-table-column prop="BusinessType.Name" label="业务类型"></el-table-column>
      <el-table-column type="selection" :reserve-selection="true"></el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      ></el-pagination>
    </div>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      form: {
        client_id: '',
        BusinessTypeID: '',
      },
      pager: {
        total: 0,
        page: 1,
        size: 10,
      },
      rowData: {},
      itemList: [],
      loading: false,
      submitting: false,
      multipleSelection: [],
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  methods: {
    getRowKey(row) {
      return row.ID;
    },
    onOpen() {
      this.rowData = _.clone(this.value);
      this.pager.page = 1;// 从第一页开始
      this.getItemList();
    },
    onClose() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
      // 重置信息
      this.form = {
        client_id: '',
        BusinessTypeID: '',
      };
      this.$refs.multipleTable.clearSelection();
      this.multipleSelection = [];
    },
    onSubmitQuery() {
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    getItemList() {
      this.loading = true;
      this.$axios
        .get('platform', {
          params: {
            where: _.omit(this.form, 'client_id'),
            client_id: this.form.client_id,
            with: [
              'BusinessType',
            ],
            ...this.pager,
            ifprotect: this.ifprotect,
            contractnumber: this.contractnumber,
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, 'size', 'page', 'total');
        }).then(() => {
          this.itemList.forEach((item) => {
            this.rowData.Platforms.forEach((platform) => {
              if (item.ID === platform.ID) this.$refs.multipleTable.toggleRowSelection(item, true);
            });
          });
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSelectionChange(list) {
      this.multipleSelection = list.map(x => x.ID);
    },
    onSubmit() {
      this.submitting = true;
      this.$axios
        .request({
          url: `contract/${this.rowData.ID}/platform`,
          method: 'post',
          data: { PIDS: this.multipleSelection },
        })
        .then(() => {
          this.$message.success('绑定成功');
          this.submitting = false;
          this.$emit('form:saved', true);
          this.$emit('update:visible', false);
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
          this.submitting = false;
          this.$emit('form:saved', false);
        });
    },
  },
};
</script>
